import {
  FaLayerGroup,
  FaNetworkWired,
  FaServer,
  FaPlus,
  FaAndroid,
  FaMicrochip,
} from "react-icons/fa";
import { PageHeader } from "../shared";
import usePermission from "../../Hooks/usePermission";
import { DEVICE_ACTIVITY_STATE_OPEN } from "../../utils/deviceActivityLabels";

export default function DeviceInfoMetrics({
  deviceDetailIsLoading,
  totalDevices,
  devices,
  onDeviceClick,
  isDealer = false,
}) {
  const { hasPermission } = usePermission();
  const activeCount = devices.filter((d) => d.isActive)?.length || 0;

  const stats = [
    { label: "Cihaz", value: totalDevices, icon: FaLayerGroup, color: "indigo" },
    { label: DEVICE_ACTIVITY_STATE_OPEN, value: activeCount, icon: FaNetworkWired, color: "emerald" },
  ];

  const actions = [];

  if (hasPermission("devices.distribution")) {
    actions.push({
      label: "Tüm Cihazlar",
      icon: FaLayerGroup,
      onClick: () => {
        if (!deviceDetailIsLoading) onDeviceClick("all");
      },
      variant: "primary",
    });
  }

  if (!isDealer && hasPermission("devices.apkRead")) {
    actions.push({
      label: "APK Güncelleme",
      icon: FaAndroid,
      onClick: () => {
        if (!deviceDetailIsLoading) onDeviceClick("apk");
      },
      variant: "primary",
    });
  }

  if (!isDealer && hasPermission("devices.hardwareRead")) {
    actions.push({
      label: "Hardware Yükleme",
      icon: FaMicrochip,
      onClick: () => {
        if (!deviceDetailIsLoading) onDeviceClick("hardware");
      },
      variant: "primary",
    });
  }

  if (!isDealer && hasPermission("devices.create") && onDeviceClick && typeof onDeviceClick === "function") {
    actions.push({
      label: "Cihaz Oluştur",
      icon: FaPlus,
      onClick: () => {
        if (!deviceDetailIsLoading) onDeviceClick("create");
      },
      variant: "success",
    });
  }

  return (
    <PageHeader
      icon={FaServer}
      iconColor="indigo"
      title={isDealer ? "Cihazlarım" : "Cihaz Yönetimi"}
      subtitle={isDealer ? "Bayi ağınızdaki cihazları görüntüleyin ve takip edin" : "Cihaz bilgilerini yönetin ve takip edin"}
      stats={stats}
      actions={actions}
      isLoading={deviceDetailIsLoading}
      mobileSlotId="devices-toolbar-mobile-slot"
    />
  );
}
